import { useDispatch, useSelector } from "react-redux";
import {
  StyledImageContainer,
  StyledTitle,
} from "../../../components/ModalComponents/StyledModalComponents";
import {
  currentlyEditingSleeperSelector,
  isIncorporateModalOpenSelector,
  setIsIncorporateModalOpen,
} from "../../../redux/slices/customNavigation";
import {
  getFirstName,
  getPainPointsInfoMessage,
  getPainPointsSVG,
} from "../../../utils/bedBuilder.utils";
import { useTheme } from "@mui/styles";
import { useTranslation } from "react-i18next";

import ContainedButton from "../../../components/Buttons/ContainedButton";

import React from "react";

import { getAdaptiveFontSize } from "../../../utils/styling.utils";
import {
  isSingleSleeperSelector,
  primarySleeperFirmnessSelector,
  secondarySleeperFirmnessSelector,
} from "../../../redux/slices/mattressConfiguration";
import evrbed_firmness_background from "../../../assets/images/evrbed_firmness_background.svg";

import styled from "styled-components";
import useMediaQuery from "@mui/material/useMediaQuery";

const StyledTextContainer = styled.div`
  width: 35vw;
  height: 5vh;
  position: absolute;
  padding-left: 7vw;
  padding-right: 5vw;
`;

const StyledFirmness = styled.div`
  text-decoration: underline;
  font-family: noto-sans;
  margin-top: 1vh;
`;

const StyledSubTitle = styled.div`
  font-family: noto-sans;
  font-size: 1.2rem;
  font-weight: bold;
  width: 20vw;
  padding-right: 3vw;
  margin-left: -2vw;
`;

const SleeperFirmnessModal = () => {
  const { t } = useTranslation();
  const theme = useTheme();
  const dispatch = useDispatch();
  //Media Queries
  const isSmallScreen = useMediaQuery("(min-width: 500px)");
  const isMediumScreen = useMediaQuery("(min-width: 768px)");
  const isLargeScreen = useMediaQuery("(min-width: 992px)");
  const isExtraLargeScreen = useMediaQuery("(min-width: 1200px)");
  const screenWidthHooks = {
    isSmallScreen,
    isMediumScreen,
    isLargeScreen,
    isExtraLargeScreen,
  };

  const isIncorporateModalOpen = useSelector(isIncorporateModalOpenSelector);

  const isSingleSleeper = useSelector(isSingleSleeperSelector);

  const currentlyEditingSleeper = useSelector(currentlyEditingSleeperSelector);

  const editingSleeper1 = currentlyEditingSleeper === 1;

  const primarySleeperFirmness = useSelector(primarySleeperFirmnessSelector);
  const secondarySleeperFirmness = useSelector(
    secondarySleeperFirmnessSelector
  );

  const firmnessIndex =
    isSingleSleeper || editingSleeper1
      ? primarySleeperFirmness
      : secondarySleeperFirmness;

  return (
    <div
      className="col-5"
      style={{
        position: "relative",
        marginTop: isExtraLargeScreen ? "-10vh" : "30vh",
      }}
    >
      <>
        <StyledImageContainer className="mx-auto">
          <img
            style={{
              width: "30vw",
              height: "45vh",
            }}
            src={evrbed_firmness_background}
          ></img>
        </StyledImageContainer>

        <StyledTextContainer
          style={{ marginTop: isExtraLargeScreen ? "-37vh" : "-33vh" }}
        >
          <div className="row">
            <StyledTitle
              className="col-6"
              style={{
                color: theme.COLORS.BLUE.darkBlueGreen,
                marginTop: "2vh",
                fontSize: getAdaptiveFontSize({
                  screenWidthHooks,
                  fontSize: 1.3,
                }),
              }}
            >
              {getFirstName()},<br></br>
              {t("Your Firmness is:")}
            </StyledTitle>
            <StyledFirmness
              className="col-3"
              style={{
                fontSize: getAdaptiveFontSize({
                  screenWidthHooks,
                  fontSize: 2.8,
                }),
              }}
            >
              {firmnessIndex}
            </StyledFirmness>
          </div>
          <StyledSubTitle
            className="col-9"
            style={{
              color: theme.COLORS.BLUE.darkBlueGreen,
              fontSize: getAdaptiveFontSize({
                screenWidthHooks,
                fontSize: 1.1,
              }),
              marginTop: isExtraLargeScreen ? "4vh" : "3vh",
              marginLeft: "0px",
            }}
          >
            {t(
              "Our Sleep Experts are reviewing this against your other inputs and will insure this is the best selection for you!"
            )}
            <br></br>
          </StyledSubTitle>

          <ContainedButton
            className="col-auto"
            styles={{
              textTransform: "upperCase",
              fontSize: getAdaptiveFontSize({
                screenWidthHooks,
                fontSize: 0.8,
              }),
              marginTop: isExtraLargeScreen ? "4vh" : "2vh",
            }}
            onClick={() =>
              dispatch(setIsIncorporateModalOpen(!isIncorporateModalOpen))
            }
          >
            {t("How does this affect")}
            <br></br>
            {t("my evrbed?")}
          </ContainedButton>
        </StyledTextContainer>
      </>
    </div>
  );
};

export default SleeperFirmnessModal;
